import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import Avatar from './Avatar';
import NavigationButtons from './NavigationButtons';
import { useLanguage } from '../context/LanguageContext';

const NotFound = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const txt = {
    es: {
      title: 'Página No Encontrada',
      message: 'Lo sentimos, la página que buscas no existe o ha sido movida.',
      goBack: 'Regresar',
      goToDashboard: 'Ir al Dashboard',
      footer: 'DamyxIA - Inteligencia Digital Modular'
    },
    en: {
      title: 'Page Not Found',
      message: 'Sorry, the page you are looking for does not exist or has been moved.',
      goBack: 'Go Back',
      goToDashboard: 'Go to Dashboard',
      footer: 'DamyxIA - Modular Digital Intelligence'
    }
  };
  const t = txt[language] || txt.es;

  return (
    <div className="min-h-[100dvh] flex items-center justify-center p-4 bg-zinc-950 welcome-bg transition-colors duration-300">
      <NavigationButtons showBack={true} showHome={true} />
      
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,rgba(99,102,241,0.08),transparent_50%)] pointer-events-none" />
      
      <div className="relative z-10 w-full max-w-md text-center">
        <div className="flex justify-center mb-6">
          <Avatar size="lg" />
        </div>
        
        <div className="sidebar-bg border border-zinc-800/50 border-custom rounded-2xl p-8 shadow-2xl">
          <AlertCircle className="w-16 h-16 text-indigo-500 mx-auto mb-4" />
          <h2 className="text-3xl font-outfit font-medium text-zinc-100 text-primary mb-2">
            404
          </h2>
          <h3 className="text-xl font-medium text-zinc-300 text-primary mb-4">
            {t.title}
          </h3>
          <p className="text-zinc-400 text-secondary mb-6">
            {t.message}
          </p>
          
          <div className="flex gap-3 justify-center">
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-3 bg-zinc-700 hover:bg-zinc-600 text-white font-medium rounded-lg transition-colors duration-200"
            >
              {t.goBack}
            </button>
            <button
              onClick={() => navigate('/')}
              className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition-colors duration-200"
            >
              {t.goToDashboard}
            </button>
          </div>
        </div>

        <div className="text-center mt-6 text-xs text-zinc-600 text-muted">
          <p>{t.footer}</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
